module.exports = __webpack_public_path__ + "media/images/tab-bg-86088c5b3ab1f386f06258a6b60eff5d.jpg";